/** WhatsApp number in international format without + or spaces (for wa.me links). */
export const WHATSAPP_PHONE = '8618273950322'

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_PHONE}`
